
















































































































































































































































































































































import { Component, PropSync, Prop, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import {
  DistributionChannelTypesEnum,
  PropertyOtaView,
  ReservationAccUnitModel,
  ReservationModel,
  SearchRestrictionsModel,
} from "./types";
import { ReservationStatus } from "@/shared/models/reservationStatus";
import DateField, {
  formatCountOfNights,
} from "@/components/misc/DateField.vue";
import MoreLessSelect from "@/components/misc/MoreLessSelect.vue";
import FormDescription from "@/components/misc/FormDescription.vue";
import * as _ from "lodash";
import { DistributionChannelType } from "@/shared/models/distributionChannelType";
import { Ota } from "@/shared/models/ota";
import NumericPicker from "@/components/misc/NumericPicker.vue";
import { PaymentMean } from "@/shared/models/paymentMean";
import { CardType } from "@/shared/models/cardType";
import CreditCardInfoModal from "@/components/credit-card/CreditCardInfoModal.vue";
import PaymentGatewayTransactionLogModal from "@/components/credit-card/PaymentGatewayTransactionLogModal.vue";
import { SalesChannelView } from "@/shared/models/salesChannel";
import { Notification } from "../../store/modules/notifications";
import {
  PaymentMeansEnum,
  ReservationStatusEnum,
  TenantTypesEnum,
} from "@/shared/models/enums.type";
import { CustomerModel } from "@/shared/models/vCustomer";
import {
  differenceInDays,
  parseStringToDateJS,
} from "@/shared/dateFormatUtils";
import { policyChecker } from "@/shared/roles";
import { JwtClaims } from "@/store/modules/auth";

@Component({
  components: {
    DateField,
    MoreLessSelect,
    FormDescription,
    NumericPicker,
    CreditCardInfoModal,
    PaymentGatewayTransactionLogModal,
  },
})
export default class ReservationFormStayPeriod extends Vue {
  @PropSync("reservation") model?: ReservationModel;

  @Prop({ default: undefined }) period?: Date[];
  @Prop({ default: undefined }) restrictions?: SearchRestrictionsModel;
  @Prop({ default: false }) isModalOpen?: boolean;
  @Prop() isMobile?: boolean;

  @Getter("auth/claims") claims?: JwtClaims;

  @Action("codebooks/refreshOtas") refreshOtas?: () => Promise<void>;
  @Getter("codebooks/otas") otas?: Ota[];

  @Action("codebooks/refreshSalesChannels")
  refreshSalesChannels?: () => Promise<void>;
  @Getter("codebooks/salesChannels") salesChannels?: SalesChannelView[];

  @Action("codebooks/refreshDistributionChannelTypes")
  refreshDistributionChannelTypes?: () => Promise<void>;
  @Getter("codebooks/distributionChannelTypes")
  distributionChannelTypes?: DistributionChannelType[];

  @Action("codebooks/refreshPaymentMeans")
  refreshPaymentMeans?: () => Promise<void>;
  @Getter("codebooks/paymentMeans") paymentMeans?: PaymentMean[];
  @Action("codebooks/refreshCardTypes") refreshCardTypes?: () => Promise<void>;
  @Getter("codebooks/cardTypes") cardTypes?: CardType[];

  @Getter("appParams/typeId") tenantTypeId?: number;

  get stayPeriodDatesText() {
    return formatCountOfNights(this)(this.stayPeriodDates);
  }

  get isAllowedToModifyDistributionChannel() {
    return policyChecker("MODIFY_DISTRIBUTION_CHANNEL")(this.claims);
  }

  get isAllowedToReadPaymentMeans() {
    return policyChecker("READ_PAYMENT_MEANS")(this.claims);
  }

  get isAllowedToReadReservationStatus() {
    return policyChecker("READ_RESERVATION_STATUS")(this.claims);
  }

  get isTenantTypeAgency() {
    return this.tenantTypeId === TenantTypesEnum.Agency;
  }

  get allowedDistributionChannelTypes() {
    if (!this.distributionChannelTypes) {
      return [];
    }
    const types = _.cloneDeep(this.distributionChannelTypes);

    if (this.isTenantTypeAgency) {
      return types;
    } else {
      return types?.filter(
        (channel) =>
          channel.id != DistributionChannelTypesEnum.OwnersReservation
      );
    }
  }

  @Action("codebooks/refreshReservationStatuses")
  refreshReservationStatuses?: () => Promise<void>;
  @Getter("codebooks/reservationStatuses")
  reservationStatuses?: ReservationStatus[];

  distributionChannelsChanged() {
    if (
      this.model?.distributionChannelTypeId ==
        DistributionChannelTypesEnum.WalkIn &&
      !this.model.id
    ) {
      //change status to Confirmed
      this.model.statusId = ReservationStatusEnum.Confirmed;
    }

    if (
      this.model &&
      this.model.distributionChannelTypeId == DistributionChannelTypesEnum.OTA
    ) {
      this.model.salesChannelId = null;
      this.calculateOTACommssion();
    } else if (
      this.model &&
      this.model.distributionChannelTypeId ==
        DistributionChannelTypesEnum.OTAConversion
    ) {
      this.model.salesChannelId = null;
    } else if (this.model) {
      this.model.salesChannelId = null;
      this.model.otaid = null;
    }

    if (
      this.model &&
      this.model.distributionChannelTypeId !=
        DistributionChannelTypesEnum.OTA &&
      this.model.distributionChannelTypeId !=
        DistributionChannelTypesEnum.PartnerAgency
    ) {
      this.model?.accomodationUnitTypes.forEach((unitType) => {
        unitType.channelCommissionPercent = 0;
        unitType.channelCommission = 0;
      });
    }

    return;
  }

  customerFromSalesChannel: CustomerModel | undefined;

  async salesChannelChanged() {
    const pickedSalesChannel = this.salesChannels?.find(
      (x) => x.id == this.model?.salesChannelId
    );
    this.model?.accomodationUnitTypes.forEach((unitType) => {
      if (this.model && this.model.salesChannelId) {
        unitType.channelCommissionPercent = pickedSalesChannel
          ? pickedSalesChannel.commissionPercent
          : 0;
        unitType.channelCommission = this.calculateChannelCommission(unitType);
      }
    });
    if (pickedSalesChannel?.defaultRatePlanId && this.model) {
      this.model.isManualSalesChannelChanged = true;
    }

    //show notification to apply changes to reservationHolder if reservationHolder already exists
    if (
      this.model &&
      pickedSalesChannel?.defaultCustomerId &&
      pickedSalesChannel?.defaultCustomerId != this.model.customerId
    ) {
      if (pickedSalesChannel && pickedSalesChannel?.defaultCustomerId) {
        const id = pickedSalesChannel.defaultCustomerId;
        await this.axios
          .get<CustomerModel>("/customers/" + id)
          .then((res) => {
            if (this.model) {
              this.customerFromSalesChannel = res.data;
            }
          })
          .finally();
      }
      if (this.model.customerId) {
        this.$store.dispatch("showNotification", {
          color: "warning",
          message: this.$t("ReservationForm.ChangeReservationHolder", {
            client: this.customerFromSalesChannel?.legalEntityName,
          }),
          actions: [
            {
              text: this.$t("Yes"),
              fun: () => {
                this.setReservationHolderOnSalesChannelChange();
                return true;
              },
            },
            {
              text: this.$t("Cancel"),
              fun: () => {
                return true;
              },
            },
          ],
          timeout: 10000,
        } as Notification);
      } else {
        this.setReservationHolderOnSalesChannelChange();
      }
    }
  }

  otaChanged() {
    if (
      this.model?.distributionChannelTypeId == DistributionChannelTypesEnum.OTA
    ) {
      this.calculateOTACommssion();
    }
  }

  async setReservationHolderOnSalesChannelChange() {
    const pickedSalesChannel = this.salesChannels?.find(
      (x) => x.id == this.model?.salesChannelId
    );

    if (pickedSalesChannel && pickedSalesChannel?.defaultCustomerId) {
      if (this.model && this.customerFromSalesChannel) {
        this.model.customerId = this.customerFromSalesChannel.id;
        this.model.customer.id = this.customerFromSalesChannel.id;
        this.model.customer.name = this.customerFromSalesChannel.legalEntityName
          ? this.customerFromSalesChannel.legalEntityName
          : "";
        this.model.customer.eMail = this.customerFromSalesChannel.eMail
          ? this.customerFromSalesChannel.eMail
          : "";
        this.model.customer.telephoneNumber = this.customerFromSalesChannel
          .telephoneNumber
          ? this.customerFromSalesChannel.telephoneNumber
          : "";
        this.model.customer.countryOfResidenceId = this.customerFromSalesChannel
          .countryOfResidenceId
          ? this.customerFromSalesChannel.countryOfResidenceId
          : 0;
      }
    }
  }

  calculateChannelCommission(unitType: ReservationAccUnitModel) {
    let totalPrice = 0;
    if (unitType.dayPrices) {
      totalPrice = unitType.dayPrices.reduce((sum, e) => sum + e.price, 0);
    }

    if (unitType.discountPercent) {
      totalPrice = totalPrice * (1 - unitType.discountPercent / 100);
    }

    const servicePriceWithoutTax = unitType.selectedServices
      .filter((s) => !s.isCityTax)
      .reduce((acc, s) => acc + s.grossPrice, 0);

    return (
      (totalPrice + servicePriceWithoutTax) *
      ((unitType.channelCommissionPercent ?? 0) / 100)
    );
  }

  // This is needed for when number of nights changes. we need to calculate previous commission to determine if we need to update.
  previousNumberOfNights = null as number | null;
  calculateOTACommssion() {
    this.model?.accomodationUnitTypes.forEach(async (unitType) => {
      if (this.model && this.model.otaid && unitType.propertyId) {
        const otaCommissionData = await this.getOtaCommissionPercentage(
          unitType.propertyId,
          this.model.otaid
        );

        unitType.channelCommissionPercent = otaCommissionData.percent;
        unitType.ownerPaysOTACommission =
          otaCommissionData.ownerPaysOTACommission;
        unitType.channelCommission = this.calculateChannelCommission(unitType);

        this.calculateInputPrices(unitType);
      }
    });
  }

  calculateInputPrices(unitType: ReservationAccUnitModel) {
    unitType.channelCommission = this.calculateChannelCommission(unitType);

    // This is used to recalculate new input prices .
    if (
      unitType.ownerPaysOTACommission &&
      unitType.inputPriceWasManuallyChanged
    )
      unitType.dayPrices
        .filter((dp) => dp.inputPrice === dp.inputPriceBeforeCommission)
        .forEach((x) => {
          x.inputPrice = x.inputPriceBeforeCommission;
        });
    // This is used to revert to input price before commission if price was not manually changed and new OTA has no checkbox for the owner to pay the commission.
    else if (
      !unitType.ownerPaysOTACommission &&
      !unitType.inputPriceWasManuallyChanged
    )
      unitType.dayPrices.forEach((x) => {
        x.inputPrice = x.inputPriceBeforeCommission;
      });
  }

  get numberOfNights() {
    if (this.model?.arrivalDate && this.model?.departureDate) {
      const numberOfDays = differenceInDays(
        new Date(this.model.arrivalDate),
        new Date(this.model.departureDate)
      );
      return isFinite(numberOfDays) && numberOfDays > 0 ? numberOfDays : 1;
    } else {
      return 0;
    }
  }
  async getOtaCommissionPercentage(propertyId: number, otaId: number) {
    let percent = 0;
    let ownerPaysOTACommission = false;

    await Vue.axios
      .post<PropertyOtaView>("reservations/getPropertyOta", {
        propertyId: propertyId,
        otaId: otaId,
      })
      .then((res) => {
        percent = res.data.commissionPercent;
        ownerPaysOTACommission = res.data.ownerPaysOTACommission;
      });

    return {
      percent,
      ownerPaysOTACommission,
    };
  }

  getSalesChannelCommissionPercentage(salesChannelId: number) {
    let percent = 0;
    if (this.salesChannels) {
      const salesChannel = this.salesChannels.find(
        (x) => x.id == salesChannelId
      );

      percent = salesChannel?.commissionPercent ?? 0;
    }

    return percent;
  }

  get allowedReservationStatues() {
    if (!this.reservationStatuses) {
      return [];
    }

    const result = _.cloneDeep(this.reservationStatuses);
    result.forEach(
      (x: any) => (x.disabled = x.name != "Hold" && x.name != "Confirmed")
    );

    return result;
  }

  async created() {
    const promises = [];

    if (
      (this.reservationStatuses?.length ?? 0) === 0 &&
      this.refreshReservationStatuses
    ) {
      promises.push(this.refreshReservationStatuses());
    }

    if (
      (this.distributionChannelTypes?.length ?? 0) === 0 &&
      this.refreshDistributionChannelTypes
    ) {
      promises.push(this.refreshDistributionChannelTypes());
    }

    if ((this.otas?.length ?? 0) === 0 && this.refreshOtas) {
      promises.push(this.refreshOtas());
    }

    if ((this.salesChannels?.length ?? 0) === 0 && this.refreshSalesChannels) {
      promises.push(this.refreshSalesChannels());
    }

    if ((this.paymentMeans?.length ?? 0) === 0 && this.refreshPaymentMeans) {
      promises.push(this.refreshPaymentMeans());
    }

    if ((this.cardTypes?.length ?? 0) === 0 && this.refreshCardTypes) {
      promises.push(this.refreshCardTypes());
    }

    await Promise.all(promises);
  }

  get numberOfSelectedUnits() {
    if (this.model) {
      return this.model.accomodationUnitTypes.length || 0;
    }
    return 0;
  }

  get numberOfSituatedGuests() {
    let numberOfGuests = 0;
    if (this.model) {
      for (const unit of this.model.accomodationUnitTypes) {
        numberOfGuests += unit.numberOfAdults || 0;
        numberOfGuests += unit.numberOfChildren || 0;
      }
    }

    return numberOfGuests;
  }

  get availableOccupancy() {
    let availableOccupancy = 0;

    if (this.model) {
      for (const unit of this.model.accomodationUnitTypes) {
        availableOccupancy += unit.allowedOccupancy;
      }
    }

    return availableOccupancy;
  }

  @Watch("isModalOpen")
  openWatch(fresh: boolean) {
    if (!fresh) {
      this.stayPeriodDates = [];
    }
  }

  @Watch("period", { deep: true, immediate: true })
  periodChanged() {
    if (this.model?.id == 0 && this.model?.arrivalDate) {
      if (this.model.arrivalDate.getTime() < new Date().getTime()) {
        this.model.bookingDate = this.model.arrivalDate
          .toISOString()
          .substring(0, 10);
        this.model.statusId = ReservationStatusEnum.Confirmed;
      }
    }
    if (this.period && this.period.length === 2 && this.model) {
      this.stayPeriodDates = [
        this.period[0].toISOString().substring(0, 10),
        this.period[1].toISOString().substring(0, 10),
      ];

      if (this.model) {
        this.model.arrivalDate = new Date(this.stayPeriodDates[0]);
        this.model.departureDate = new Date(this.stayPeriodDates[1]);
      }
    } else {
      this.stayPeriodDates = [];

      if (this.model) {
        this.model.arrivalDate = null;
        this.model.departureDate = null;
      }
    }
  }

  stayPeriodDates: string[] = [];

  stayDateChanged() {
    this.model?.accomodationUnitTypes.forEach((x) => {
      this.calculateInputPrices(x);
    });
  }

  get internalPeriod() {
    return this.stayPeriodDates;
  }

  set internalPeriod(fresh: string[] | null | undefined) {
    if (_.isEqual(fresh, this.stayPeriodDates)) {
      return;
    }

    this.stayPeriodDates = fresh ?? [];

    if (this.stayPeriodDates.length == 2) {
      if (this.model) {
        this.model.arrivalDate = new Date(this.stayPeriodDates[0]);
        this.model.departureDate = new Date(this.stayPeriodDates[1]);
      }
    } else {
      if (this.model) {
        this.model.arrivalDate = null;
        this.model.departureDate = null;
      }
    }
  }

  synchronizeStayPeriodDates() {
    if (this.stayPeriodDates.length == 2) {
      this.model?.accomodationUnitTypes.forEach((el) => {
        el.arrivalDate = this.stayPeriodDates[0];
        el.departureDate = this.stayPeriodDates[1];
      });
      if (this.model) {
        this.model.arrivalDate = new Date(this.stayPeriodDates[0]);
        this.model.departureDate = new Date(this.stayPeriodDates[1]);
      }
    }
  }

  @Watch("restrictions", { immediate: true })
  restrictionsChanged() {
    if (this.restrictions && this.model) {
      this.model.numberOfAdults = this.restrictions.numberOfAdults;
      this.model.numberOfChildren = this.restrictions.numberOfChildren;
      this.model.numberOfUnits = this.restrictions.numberOfUnits;
    }
  }

  get rules() {
    return {
      required: (value: any) => !!value || this.$t("Validation.Required"),
      specificOtaRequired: (value: any) =>
        !!value ||
        !!this.model?.otareservationId ||
        this.$t("Validation.Required"),
      period: (value: any) => value || this.$t("Reservation.PeriodRequired"),
      optionExpiration: (value: any) =>
        !!value || this.$t("Reservation.OptionExpirationDateRequired"),
      optionExpirationBeforeArrival: (value: boolean) =>
        value || this.$t("Reservation.OptionExpirationMustNotBeAfterArrival"),
      bookingDateBeforeArrival: (value: boolean) =>
        value || this.$t("Reservation.BookingDateMustNotBeAfterArrival"),
      bookingDateBeforeOptionExpiration: (value: boolean) =>
        value ||
        this.$t("Reservation.BookingDateMustNotBeAfterOptionExpiration"),
      age: (value: number) =>
        ((!!value || value === 0) && value >= 0 && value % 1 == 0) ||
        this.$t("Reservation.ChildAgeMustBeWholePositiveNumber"),
      mustBeWholeNumber: (value: number) =>
        value == null ||
        value == undefined ||
        value % 1 == 0 ||
        this.$t("Validation.MustBeWholeNumber"),
      mustBePositive: (value: number) =>
        value == null ||
        value == undefined ||
        value >= 0 ||
        this.$t("Validation.MustBePositive"),
    };
  }

  get optionExpirationNotAfterArrival() {
    if (this.model?.arrivalDate && this.model.optionExpirationDate) {
      return (
        this.model.arrivalDate.getTime() >=
        new Date(this.model.optionExpirationDate).getTime()
      );
    }

    return true;
  }

  get optionExpirationMaxDate() {
    if (this.model?.arrivalDate) {
      return this.model.arrivalDate.toISOString().substring(0, 10);
    }

    return undefined;
  }

  get bookingDateMaxDate() {
    let arrivalDate;
    let optionExpDate;

    if (this.model?.arrivalDate) {
      arrivalDate = this.model.arrivalDate.toISOString().substring(0, 10);
    }
    if (this.model?.optionExpirationDate) {
      optionExpDate = this.model.optionExpirationDate.substring(0, 10);
    }

    if (arrivalDate && optionExpDate) {
      return arrivalDate <= optionExpDate ? arrivalDate : optionExpDate;
    } else if (arrivalDate) {
      return arrivalDate;
    } else if (optionExpDate) {
      return optionExpDate;
    }

    return undefined;
  }

  get bookingDateNotAfterArival() {
    if (this.model?.arrivalDate && this.model.bookingDate) {
      return (
        parseStringToDateJS(this.model.bookingDate).toISOString() <=
        parseStringToDateJS(this.model.arrivalDate.toString()).toISOString()
      );
    }

    return true;
  }

  get bookingDateNotAfterOptionExpiration() {
    if (this.model?.optionExpirationDate && this.model.bookingDate) {
      return this.model.statusId === 1
        ? parseStringToDateJS(this.model.bookingDate).toISOString() <=
            parseStringToDateJS(this.model.optionExpirationDate).toISOString()
        : true;
    }

    return true;
  }

  get showCardTypeSelection() {
    let paymentMeanBaseId;

    if (this.paymentMeans) {
      paymentMeanBaseId = this.paymentMeans.find(
        (_) => this.model?.paymentMeansId === _.id
      )?.paymentMeanBaseId;
    }

    const paymentMeansId = this.model?.paymentMeansId ?? 0;

    if (
      paymentMeansId === PaymentMeansEnum.KreditnaKartica ||
      paymentMeansId === PaymentMeansEnum.BankovnaKartica ||
      paymentMeanBaseId === PaymentMeansEnum.KreditnaKartica ||
      paymentMeanBaseId === PaymentMeansEnum.BankovnaKartica
    ) {
      return true;
    } else {
      if (this.model) this.model.cardTypeId = null;
      return false;
    }
  }

  get numberOfAdults() {
    return this.model?.numberOfAdults ?? 0;
  }

  set numberOfAdults(value: number | null) {
    if (this.model) {
      this.model.numberOfAdults = value ?? 0;
    }
  }

  get numberOfChildren() {
    return this.model?.numberOfChildren ?? 0;
  }

  set numberOfChildren(value: number | null) {
    if (this.model) {
      this.model.numberOfChildren = value ?? 0;
    }
  }

  get numberOfPets() {
    return this.model?.numberOfPets ?? 0;
  }

  set numberOfPets(value: number | null) {
    if (this.model) {
      this.model.numberOfPets = value ?? 0;
    }
  }
}
